module.exports = __webpack_public_path__ + "img/11.91ddfa2b.jpg";